import React from "react";
import OpenApp from "react-open-app";
import MailIcon from "../assets/svg/MailIcon";
import TelegramIcon from "assets/svg/TelegramIcon";
import XIcon from "assets/svg/XIcon";

function ShareComponent({ eventData, style = {}, isHomePressPage = false }) {
  return (
    <div className="icons-container" style={style}>
      <div className="icon twitter disable-long-press">
        <OpenApp href="https://x.com/timelesswallet">
          <XIcon />
        </OpenApp>
      </div>
      <div className="icon disable-long-press">
        <OpenApp href="https://t.me/timelessfrens">
          <TelegramIcon />
        </OpenApp>
      </div>
      <div className="icon email disable-long-press">
        <OpenApp href="mailto:hey@timelesswallet.xyz?subject=Timeless Wallet">
          <MailIcon />
        </OpenApp>
      </div>
    </div>
  );
}

export default ShareComponent;
